<script lang="ts" setup>

import {computed} from 'vue';

const props = defineProps<{
  title: string;
  headlineLevel?: number;
}>();

const headlineTag = computed<string>((): string => {
  const defaultLevel = 2;
  const level = Math.max(0, Math.min((props.headlineLevel ?? defaultLevel), 6));
  return `h${level}`;
});

</script>

<template>
  <section>
    <component :is="headlineTag" class="headline">
      {{ title }}
    </component>
    <div class="card">
      <slot name="default"/>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.headline {
  @include font-h3-bold;
  margin-bottom: var(--Spacing-spacing-2);
}

.card {
  @include q-card-white;
}

</style>